import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/utils.js";

const SKELETON_ROWS: readonly { outbound: boolean; widthClass: string }[] = [
  { outbound: false, widthClass: "w-[58%]" },
  { outbound: true, widthClass: "w-[46%]" },
  { outbound: false, widthClass: "w-[64%]" },
  { outbound: true, widthClass: "w-[52%]" },
  { outbound: false, widthClass: "w-[40%]" },
];

/** Compact in-place loading treatment for the message history area. */
export function ConversationMessagesSkeleton(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div
      className="flex w-full flex-col gap-2.5 py-1"
      role="status"
      aria-busy="true"
      aria-label={t("inbox.loadingMessages")}
    >
      {SKELETON_ROWS.map((row, index) => (
        <div
          key={index}
          className={cn("flex", row.outbound ? "justify-end" : "justify-start")}
        >
          <div
            className={cn(
              "h-10 max-w-[min(36rem,65%)] max-md:max-w-[min(36rem,86%)] animate-pulse rounded-xl bg-surface-muted",
              row.widthClass,
              row.outbound ? "rounded-ee-md" : "rounded-es-md",
            )}
          />
        </div>
      ))}
    </div>
  );
}
